import {
  addDays,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  format,
  parse,
} from "date-fns";
import {
  DD_MMM_YYYY,
  DD_MMM_YYYY_HH_MM,
  DD_MMM_YYYY_HH_MM_HRS,
  YYYY_MM_DD,
} from "./valueStaticConstants";

export const formatDate = (date: Date) => {
  return format(new Date(date), YYYY_MM_DD);
};

export const addDateInDays = (date: Date, countDays: number) => {
  const reducerDate = addDays(new Date(date), countDays);
  return format(reducerDate, YYYY_MM_DD);
};

export const formatDateYYYYmmDD = (date: string) => {
  const dateParse = parse(date, YYYY_MM_DD, new Date());
  return format(new Date(dateParse), DD_MMM_YYYY);
};

export const formatDateHHMM = (dataFormat: Date) => {
  return format(dataFormat, DD_MMM_YYYY_HH_MM);
};

export const formatGetTimeLabel = (created_at) => {
  const now = new Date();
  const creationDate = new Date(created_at);
  const diffInDays = differenceInDays(now, creationDate);
  let timeAgo = "";
  if (diffInDays > 0) {
    timeAgo = format(new Date(created_at), DD_MMM_YYYY_HH_MM_HRS);
  } else {
    const diffInHours = differenceInHours(now, creationDate);
    if (diffInHours === 1) {
      timeAgo = "Hace 1 hora";
    } else if (diffInHours > 1) {
      timeAgo = `Hace ${diffInHours} horas`;
    } else {
      const diffInMinutes = differenceInMinutes(now, creationDate);
      if (diffInMinutes === 1) {
        timeAgo = "Hace 1 minuto";
      } else if (diffInMinutes > 1) {
        timeAgo = `Hace ${diffInMinutes} minutos`;
      } else {
        timeAgo = "Hace instantes";
      }
    }
  }
  return timeAgo;
};
